@if(component) {
<!-- do not remove *afterContentInit, its needed for sticky to work properly! -->
<div *afterContentInit
     class="_guide"
     [ngClass]="sidebarHidden ? '_sidebar-hidden' : 'wrap-x wrap-l p-l-5-x p-l-5-l p-r-5-x p-r-5-l'">

    <!-- heading -->
    @if (component.headingLine1 || component.headingLine2) {
    <div class="center p-t-10 p-b-10">
        <!-- first heading line -->
        @if (component.headingLine1) {
        <p class="o1"
           *iCms="'headingLine1' of component; content: 'html'"></p>
        }
        <!-- second heading line -->
        @if (component.headingLine2) {
        <p class="h2 m-t-2"
           *iCms="'headingLine2' of component; content: 'html'"></p>
        }
    </div>
    }

    <div class="pos-relative">

        <!-- show sidebar section -->
        @if (sidebarHidden && (client.isX || client.isL)) {
        <div class="_show-sidebar z-1"
             [stickyPanel]
             stickyPanelOffsetTop="full-header">

            <!-- show sidebar button -->
            <button class="flex flex-middle p-t-3 p-b-3 p-l-2 p-r-1 bg-col-5 left-0 pos-absolute"
                    (click)="toggleSidebar()">
                <!-- copy -->
                <span class="o1"
                      *iCms="'itemsTitle' of component; content: 'html'"></span>
                <!-- icon -->
                <span class="flex flex-middle flex-justify-center"
                      style="height: 1.5rem; width: 1.5rem">
                    <i class="inline-flex"
                       [ngClass]="sidebarHidden ? 'icon-chevron-right' : 'icon-chevron-left'"
                       style="font-size: 0.75rem"></i>
                </span>
            </button>
        </div>
        }

        <!-- guide container -->
        <div class="_guide-container"
             [grid]="11"
             [gridColumnGap]="0">

            @if (!sidebarHidden || client.isS || client.isM) {
            <div class="_sidebar"
                 [gridColumn]="client.isX || client.isL ? 3 : 12">
                <!-- guide indexed items -->
                <div class="flex-column z-1 bg-col-5 p-l-2 p-r-1 _guide-items"
                     [class.p-b-3]="!sidebarHidden"
                     [stickyPanel]
                     stickyPanelOffsetTop="full-header">

                    <!-- hide sidebar button -->
                    <button class="flex flex-middle flex-justify-between p-t-3 p-b-2 p-b-3-m p-b-3-s p-l-8 p-r-2 b-b-x b-b-l m-l--2 m-r--1"
                            [ngClass]="{'b-b-m b-b-s m-b-2': !sidebarHidden}"
                            (click)="toggleSidebar()">
                        <!-- copy -->
                        <span class="o1 flex-grow center"
                              *iCms="'itemsTitle' of component; content: 'html'"></span>
                        <!-- icon -->
                        <span class="flex flex-middle flex-justify-center _guide-button-icon"
                              style="height: 1.5rem; width: 1.5rem">
                            <i class="inline-flex"
                               [ngClass]="client.isX || client.isL ? (sidebarHidden ? 'icon-chevron-right' : 'icon-chevron-left') : 'icon-chevron-down ' + (sidebarHidden ? '' : 'icon-rotate')"
                               [ngStyle]="{'fontSize': client.sizeId > 1 ? '0.75rem' : '2rem'}"></i>
                        </span>
                    </button>
                    <!-- guide items list -->
                    <div class="p-l-3 p-r-3 center flex-grow overflow-y-auto custom-scrollbar _guide-items-list"
                         [class.visually-hidden]="sidebarHidden">
                        @for (item of component.items; track item; let isFirst = $first; let i = $index) {
                        <!-- guide item -->
                        <button type="button"
                                class="w-12 col-12 p-l p-r b-radius-max b-a b-col-5 bg-col-w cursor-pointer _guide-item"
                                [class.m-t-3]="!isFirst"
                                [class.is-active]="activeAnchorId === item.anchorId"
                                (click)="scrollToId(item.anchorId)">
                            <span class="p1"
                                  [innerHtml]="item.title"></span>
                        </button>
                        }
                    </div>
                </div>
            </div>
            }

            <!-- guide content -->
            <div [gridColumn]="(client.isX || client.isL) && !sidebarHidden ? 8 : 11"
                 [ngClass]="{'p-l-4-x p-l-4-l': !sidebarHidden}">

                <!-- guide cms outlet -->
                <icms-outlet [components]=" component.components ">
                </icms-outlet>
            </div>
        </div>
    </div>
</div>
}
